module.exports = "/_next/static/images/hatchback-d60ab0eb0ef969039c62019096fc4854.jpg";